/**
 * Documentation here:
 * https://confluence.mail.ru/display/GODWEB/Google+Tag+Manager+Custom+Events
 *
 */
class GTM {
  constructor() {
    this.resolution_list = {};
    this.white_listed_events = [
      "ch.purchase.init",
      "ch.purchase.finish",
      "ch.visit", // deprecated
      "ch.visit.v2",
      "ch.registration.init",
      "ch.registration.project",
      "ch.registration.finish",
      "ch.mailer.subscribed",
      "ch.click.download",
      "cb.open.video",
    ];
  }

  /* we get the list of certain events from each component interested in their completion in the following format
    GTM.gtmComplete(["ch.registration.finish", 'billing']).then(() => {
      this.doSomething()
    });
   We can register events from multiple components within the single page

   We store them in the below format
     this.resolution_list = {
       [component_name] : {
        events_awaiting_completion : ['ch.purchase.init', 'ch.visit']
        resolveCompletion: fn(){} //promise that will be resolved on completion of those events to notify the component
      }
     }
 */
  gtmComplete(events, component_name) {
    let valid_events = events.filter(e => {
      return this.white_listed_events.indexOf(e) > -1;
    });
    this.resolution_list[component_name] = {
      events_awaiting_completion: valid_events,
      resolveCompletion: null,
    };
    return new Promise(resolve => {
      this.resolution_list[component_name].resolveCompletion = resolve;
    });
  }

  /* when a certain event is complete we loop through the components list in this.resolution_list
    and look for the event
    when we find one, we
    1. remove it from the list
    2. check if the list for the component is empty, i.e. all events are done for this component
    3. if so we resolve the promise for the component notifying it
    4. we remove the component from this.resolution_list
    (which would help us at some point if we need to register a new watcher, e.g. on completion of the purchase)
  */

  removeEventFromWaitingList(event_data) {
    for (let component in this.resolution_list) {
      let component_data = this.resolution_list[component];

      let positionEventInArray = component_data.events_awaiting_completion.indexOf(
        event_data.event
      );
      if (positionEventInArray > -1) {
        component_data.events_awaiting_completion.splice(positionEventInArray, 1);
      }
      if (!component_data.events_awaiting_completion.length && component_data.resolveCompletion) {
        component_data.resolveCompletion();
        delete this.resolution_list[component];
      }
    }
  }

  sendEvent(event, data) {
    if (typeof window.dataLayer !== "undefined") {
      window.dataLayer.push(this.buildDataForSending(event, data));
    }
  }

  buildDataForSending(event, data) {
    let event_data = {
      event: event,
    };
    if (data) {
      if (data.userID) {
        event_data.userID = data.userID;
      }
      if (data.currency) {
        event_data.currency = data.currency;
      }
      if (data.price) {
        event_data.price = data.price;
      }
      if (data.offerName) {
        event_data.offerName = data.offerName;
      }
      if (data.type) {
        event_data.type = data.type;
      }
      if (data.youtube_id) {
        event_data.youtube_id = data.youtube_id;
      }
    }

    event_data["eventCallback"] = () => {
      // once the event is complete we need to check if there are any components waiting for completion
      this.removeEventFromWaitingList(event_data);
    };
    return event_data;
  }
}

const gtmService = new GTM();
export default gtmService;
